import React from 'react';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  /** 'lg' for content that needs the room — code blocks, config snippets. */
  size?: 'md' | 'lg';
  children: React.ReactNode;
}

const widths = { md: 'max-w-md', lg: 'max-w-2xl' };

export function Modal({ open, onClose, title, size = 'md', children }: ModalProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative rounded-xl border border-white/10 p-6 w-full ${widths[size]}`} style={{ background: '#1A1A2E' }}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-white">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
